import dayjs from "dayjs";

export const formatTime = (value?: string, FORMAT = "DD/MM/YYYY HH:mm:ss") => {
  return value ? dayjs(value).format(FORMAT) : "";
};
